import { render, staticRenderFns } from "./procedureMatrixInput.vue?vue&type=template&id=71e1b68e&scoped=true"
import script from "./procedureMatrixInput.vue?vue&type=script&lang=js"
export * from "./procedureMatrixInput.vue?vue&type=script&lang=js"
import style0 from "./procedureMatrixInput.vue?vue&type=style&index=0&id=71e1b68e&prod&lang=less"
import style1 from "./procedureMatrixInput.vue?vue&type=style&index=1&id=71e1b68e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1b68e",
  null
  
)

export default component.exports